import { Formik } from "formik"
import React, { useRef } from "react"

import RentalDeviceOptions from "./RentalDeviceOptions"
import { Color } from "../../../constants/V2/color"
import {
  RENTAL_READER_LEAD_IDS,
  NUMBER_OF_DEVICES_OPTIONS,
  RENTAL_READER_INITIAL_VALUES,
  RENTAL_READER_VALIDATION_SCHEMA,
  IS_EXISTING_YOCO_MERCHANT_OPTIONS,
  getSelectedInterestedProduct,
} from "../../../constants/V2/rentalReaderForm"
import { WEB_TO_LEAD_FORM_IDS } from "../../../constants/V2/salesForm"
import PillButton from "../../elements/V2/Buttons/PillButton"
import DropdownInput from "../../elements/V2/Inputs/DropdownInput"
import PhoneNumberInput from "../../elements/V2/Inputs/PhoneNumberInput"
import TextInput from "../../elements/V2/Inputs/TextInput"
import Typography from "../../elements/V2/Typography"

const RentalReaderForm = () => {
  const formElement: React.MutableRefObject<HTMLFormElement | null> =
    useRef(null)

  const submitForm = async () => {
    if (formElement.current) {
      // TODO: try remove unwanted fields from SF payload
      formElement.current.submit()
    }
  }

  return (
    <form
      ref={formElement}
      action={`${process.env.GATSBY_WEB_TO_LEAD_POST_URL}&orgId=${process.env.GATSBY_WEB_TO_LEAD_SALESFORCE_OID}`}
      method="POST"
      className="flex flex-col justify-center"
    >
      <Formik
        initialValues={RENTAL_READER_INITIAL_VALUES}
        validationSchema={RENTAL_READER_VALIDATION_SCHEMA}
        onSubmit={submitForm}
        validateOnChange
        enableReinitialize
      >
        {({ handleSubmit, errors, touched, values }) => {
          const interestedProduct = getSelectedInterestedProduct(values)[0]

          return (
            <>
              <input
                type="hidden"
                name="oid"
                value={RENTAL_READER_LEAD_IDS.oid}
              />
              <input type="hidden" name="retURL" value="http://yoco.com" />
              <input
                type="hidden"
                id={RENTAL_READER_LEAD_IDS.interestedProduct}
                name={RENTAL_READER_LEAD_IDS.interestedProduct}
                value={interestedProduct || ""}
              />
              <Typography
                color={Color.Black}
                text="1. Tell us more about yourself"
                font="grotesk"
                size="body-lg"
                weight="medium"
                className="mb-16"
              />
              <div className="grid gap-16 sm:grid-cols-2">
                <TextInput
                  required
                  type="text"
                  maxLength={40}
                  label="Name"
                  placeholder="Your first name"
                  id={WEB_TO_LEAD_FORM_IDS.first_name}
                  name={WEB_TO_LEAD_FORM_IDS.first_name}
                />

                <TextInput
                  required
                  type="text"
                  maxLength={80}
                  label="Surname"
                  placeholder="Your last name"
                  id={WEB_TO_LEAD_FORM_IDS.last_name}
                  name={WEB_TO_LEAD_FORM_IDS.last_name}
                />

                <TextInput
                  required
                  type="text"
                  maxLength={80}
                  label="Email"
                  placeholder="youremail@example.com"
                  id={WEB_TO_LEAD_FORM_IDS.email}
                  name={WEB_TO_LEAD_FORM_IDS.email}
                />

                <PhoneNumberInput
                  required
                  label="Phone"
                  placeholder="Your phone number"
                  id={WEB_TO_LEAD_FORM_IDS.phone}
                  name={WEB_TO_LEAD_FORM_IDS.phone}
                />

                <TextInput
                  required
                  type="text"
                  maxLength={80}
                  label="Name of business"
                  placeholder="Name of your business"
                  id={WEB_TO_LEAD_FORM_IDS.company}
                  name={WEB_TO_LEAD_FORM_IDS.company}
                />

                <TextInput
                  required
                  type="text"
                  maxLength={80}
                  label="Name of event"
                  placeholder="Name of the event"
                  id={RENTAL_READER_LEAD_IDS.eventName}
                  name={RENTAL_READER_LEAD_IDS.eventName}
                />
              </div>

              <Typography
                color={Color.Black}
                text="2. Are you an existing Yoco Merchant?"
                font="grotesk"
                size="body-lg"
                weight="medium"
                className="mb-16 mt-24"
              />
              <DropdownInput
                required
                className="mb-48"
                placeholder="Select an option"
                options={IS_EXISTING_YOCO_MERCHANT_OPTIONS}
                id={RENTAL_READER_LEAD_IDS.existingYocoMerchant}
                name={RENTAL_READER_LEAD_IDS.existingYocoMerchant}
              />

              {/* TODO: Make this component a radio input */}
              <RentalDeviceOptions errors={errors} touched={touched} />

              <Typography
                color={Color.Black}
                text="4. Number of devices you require to rent?"
                font="grotesk"
                size="body-lg"
                weight="medium"
                className="mb-16"
              />
              <DropdownInput
                required
                className="mb-16"
                placeholder="Select an option"
                options={NUMBER_OF_DEVICES_OPTIONS}
                id={RENTAL_READER_LEAD_IDS.numberOfDevices}
                name={RENTAL_READER_LEAD_IDS.numberOfDevices}
              />

              <Typography
                color={Color.Black}
                text="5. Where did you hear about us?"
                font="grotesk"
                size="body-lg"
                weight="medium"
                className="mb-16 mt-32"
              />

              <TextInput
                required
                type="text"
                maxLength={80}
                label="Where did you hear about us ?"
                placeholder="Where did you hear about us ?"
                id={RENTAL_READER_LEAD_IDS.hearAboutSource}
                name={RENTAL_READER_LEAD_IDS.hearAboutSource}
              />

              <div className="mt-24">
                <PillButton
                  color={Color.Blue}
                  onClick={handleSubmit}
                  text="Submit"
                  size="large"
                  style="bordered"
                  overrideTextColor={Color.Black}
                />
              </div>
            </>
          )
        }}
      </Formik>
    </form>
  )
}

export default RentalReaderForm
